import Api from './baseApi';

export default {
    getAll: (params) => {
        let url = '/api/expectedPaymentItems';
        const queryParams = [];
        if (params && params.tenantId) queryParams.push(`tenantId=${params.tenantId}`);
        if (params && params.mpId) queryParams.push(`mpId=${params.mpId}`);
        if (params && params.transactionType !== undefined && params.transactionType !== null) queryParams.push(`transactionType=${params.transactionType}`);
        if (params && params.orderStatus !== undefined && params.orderStatus !== null) queryParams.push(`orderStatus=${params.orderStatus}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.get(url);
    },
    getById: (id) => Api.get(`/api/expectedPaymentItems/${id}`),
    create: (data) => Api.post('/api/expectedPaymentItems', data),
    update: (id, data) => Api.put(`/api/expectedPaymentItems/${id}`, data),
    delete: (id) => Api.delete(`/api/expectedPaymentItems/${id}`),
    validate: (params) => {
        let url = '/api/expectedPaymentItems/validate';
        const queryParams = [];
        if (params.transactionType !== undefined) queryParams.push(`transactionType=${params.transactionType}`);
        if (params.orderStatus !== undefined) queryParams.push(`orderStatus=${params.orderStatus}`);
        if (params.startDate) queryParams.push(`startDate=${params.startDate}`);
        if (params.endDate) queryParams.push(`endDate=${params.endDate}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.get(url);
    }
};

